import request from '@/utils/request'

// 获取单品促销价列表
export function getSingleitemList(data) {
  return request({
    url: '/newMall/activityv2/queryActivityList',
    method: 'get',
    data
  })
}

// 获取单品促销价列表启用
export function enableActivity(data) {
  return request({
    url: '/newMall/activityv2/enableActivity',
    method: 'post',
    data
  })
}

// 获取单品促销价列表暂停
export function pauseActivity(data) {
  return request({
    url: '/newMall/activityv2/pauseActivity',
    method: 'post',
    data
  })
}

// 获取单品促销价列表停止
export function stopActivity(data) {
  return request({
    url: '/newMall/activityv2/stopActivity',
    method: 'post',
    data
  })
}

// 新建单品促销价活动
export function activitySave(data) {
  return request({
    url: '/newMall/activityv2/save',
    method: 'post',
    data
  })
}

// 获取单品促销价解析模板
export function parseTemplate(data) {
  return request({
    url: '/newMall/activityv2/parseTemplate',
    method: 'post',
    data
  })
}

// 获取单品促销价模板数据
export function queryActivityProductList(data) {
  return request({
    url: '/newMall/activityv2/queryActivityProductList',
    method: 'post',
    data
  })
}

// 获取查询想接口
export function queryActivityDetail(data) {
  return request({
    url: '/newMall/activityv2/queryActivityDetail',
    method: 'get',
    data
  })
}

// 活动编辑保存接口
export function updataActivity(data) {
  return request({
    url: '/newMall/activityv2/modify',
    method: 'post',
    data
  })
}

// 导出订单列表接口
export function exportToExcel(data) {
  return request({
    url: '/newMall/activityv2/exportActivityList',
    responseType: 'blob',
    method: 'get',
    data
  })
}

// 查询搭配销列表
export function queryActivityListDx(data) {
  return request({
    url: '/newMall/collocation/activity/queryList',
    method: 'get',
    data
  })
}

// 开启搭配销列表
export function enableActivityDx(data) {
  return request({
    url: '/newMall/collocation/activity/enable',
    method: 'post',
    data
  })
}

// 暂停搭配销列表
export function pauseActivityDx(data) {
  return request({
    url: '/newMall/collocation/activity/pause',
    method: 'post',
    data
  })
}

// 停止搭配销列表
export function stopActivityDx(data) {
  return request({
    url: '/newMall/collocation/activity/stop',
    method: 'post',
    data
  })
}

// 保存搭销活动
export function saveActivityDx(data) {
  return request({
    url: '/newMall/collocation/activity/save',
    method: 'post',
    data
  })
}

// 修改搭销活动
export function modifyActivityDx(data) {
  return request({
    url: '/newMall/collocation/activity/modify',
    method: 'post',
    data
  })
}

//获取组合列表
export function queryComListDx(data) {
  return request({
    url: '/newMall/collocation/combine/pageQuery',
    method: 'get',
    data
  })
}

//置顶搭销组合
export function combineComTopDx(data) {
  return request({
    url: '/newMall/collocation/combine/top',
    method: 'POST',
    data
  })
}

//置顶搭销商品
export function combineProductTopDx(data) {
  return request({
    url: '/newMall/collocation/combine/product/top',
    method: 'POST',
    data
  })
}

//删除搭销组合
export function combineBatchDeleteDx(data) {
  return request({
    url: '/newMall/collocation/combine/batchDelete',
    method: 'POST',
    data
  })
}

//新建搭销组合
export function combineCreateDx(data) {
  return request({
    url: '/newMall/collocation/combine/create',
    method: 'POST',
    data
  })
}

//修改搭销组合
export function combineUpdateDx(data) {
  return request({
    url: '/newMall/collocation/combine/update',
    method: 'POST',
    data
  })
}

//修改搭销组合商品
export function combineProductUpdateDx(data) {
  return request({
    url: '/newMall/collocation/combine/product/update',
    method: 'POST',
    data
  })
}

//查询搭销组合详情
export function combineGetDetailDetailDx(data) {
  return request({
    url: '/newMall/collocation/combine/getDetail',
    method: 'POST',
    data
  })
}

//批量查询搭销组合信息
export function combineQueryListDx(data) {
  return request({
    url: '/newMall/collocation/combine/queryList',
    method: 'POST',
    data
  })
}

//查询搭销活动详情
export function queryDetailActivityDetailDx(data) {
  return request({
    url: '/newMall/collocation/activity/queryDetail',
    method: 'get',
    data
  })
}

//批量导入搭销活动详情
export function batchImportCombineDx(data) {
  return request({
    url: '/newMall/collocation/combine/batchImport',
    method: 'POST',
    consumes: 'multipart/form-data',
    data
  })
}

//批量导入修改搭销药师点评
export function batchUpdateEvDx(data) {
  return request({
    url: '/newMall/collocation/combine/batchUpdateEv',
    method: 'POST',
    consumes: 'multipart/form-data',
    data
  })
}

//批量导入修改搭销组合名称
export function batchUpdateNameDx(data) {
  return request({
    url: '/newMall/collocation/combine/batchUpdateName',
    method: 'POST',
    consumes: 'multipart/form-data',
    data
  })
}

//导出搭销组合列等接口
export function exportcompositeComListDx(data) {
  return request({
    responseType: 'blob',
    url: '/newMall/collocation/combine/export',
    method: 'get',
    data
  })
}

// 导出搭销活动列表接口
export function exportToExcelDx(data) {
  return request({
    url: '/newMall/collocation/activity/export',
    responseType: 'blob',
    method: 'get',
    data
  })
}

//获取满赠组合列表
export function queryListMz(data) {
  return request({
    url: '/newMall/fullgift/pageQuery',
    method: 'get',
    data
  })
}

// 开启满赠列表
export function enableActivityMz(data) {
  return request({
    url: '/newMall/fullgift/enable',
    method: 'post',
    data
  })
}

// 暂停满赠列表
export function pauseActivityMz(data) {
  return request({
    url: '/newMall/fullgift/pause',
    method: 'post',
    data
  })
}

// 停止满赠列表
export function stopActivityMz(data) {
  return request({
    url: '/newMall/fullgift/stop',
    method: 'post',
    data
  })
}

//新增满赠
export function createMz(data) {
  return request({
    url: '/newMall/fullgift/create',
    method: 'post',
    data
  })
}

//查询满赠详情
export function getDetailMz(data) {
  return request({
    url: '/newMall/fullgift/getDetail',
    method: 'get',
    data
  })
}

//编辑满赠想
export function updateDetailMz(data) {
  return request({
    url: '/newMall/fullgift/update',
    method: 'post',
    data
  })
}

//暂存详情
export function utemporarySaveDetailMz(data) {
  return request({
    url: '/newMall/fullgift/temporarySave',
    method: 'post',
    data
  })
}

// 获取秒杀活动列表
export function querySeckillActivityList(data) {
  return request({
    url: '/newMall/seckillActivity/queryActivityList',
    method: 'get',
    data
  })
}

// 秒杀活动列表启用
export function enableSeckillActivity(data) {
  return request({
    url: '/newMall/seckillActivity/enableActivity',
    method: 'post',
    data
  })
}

// 秒杀活动列表暂停
export function pauseSeckillActivity(data) {
  return request({
    url: '/newMall/seckillActivity/pauseActivity',
    method: 'post',
    data
  })
}

// 秒杀活动列表停止
export function stopSeckillActivity(data) {
  return request({
    url: '/newMall/seckillActivity/stopActivity',
    method: 'post',
    data
  })
}

// 秒杀活动新建
export function saveSeckillActivity(data) {
  return request({
    url: '/newMall/seckillActivity/save',
    method: 'post',
    data
  })
}

// 秒杀活动查询详情
export function querySeckillActivityDetail(data) {
  return request({
    url: '/newMall/seckillActivity/queryActivityDetail',
    method: 'GET',
    data
  })
}

// 秒杀活动修改
export function modifyActivitySeckill(data) {
  return request({
    url: '/newMall/seckillActivity/modify',
    method: 'post',
    data
  })
}

// 秒杀活动记录导出
export function seckillExportToExcel(data) {
  return request({
    url: '/newMall/seckillActivity/exportActSaleInfo',
    responseType: 'blob',
    method: 'POST',
    data
  })
}

// 秒杀查询活动面板
export function querySeckillDashBoard(data) {
  return request({
    url: '/newMall/seckillActivity/queryDashBoard',
    method: 'POST',
    data
  })
}

// 秒杀查询秒杀活动商品销售信息
export function querySeckillActProductSaleInfo(data) {
  return request({
    url: '/newMall/seckillActivity/queryActProductSaleInfo',
    method: 'POST',
    data
  })
}

// 秒杀活动记录导出活动面板
export function exportSeckillDashBoard(data) {
  return request({
    url: '/newMall/seckillActivity/exportDashBoard',
    responseType: 'blob',
    method: 'POST',
    data
  })
}

// 秒杀活动记录导出秒杀活动商品销售信息
export function exportSeckillActProductSaleInfo(data) {
  return request({
    url: '/newMall/seckillActivity/exportActProductSaleInfo',
    responseType: 'blob',
    method: 'POST',
    data
  })
}

// 获取抽奖活动列表
export function getLotteryActivityList(data) {
  return request({
    url: 'newMall/lotteryActivity/getLotteryActivityList',
    method: 'get',
    data
  })
}

// 抽奖活动列表启用
export function openLotteryActivity(data) {
  return request({
    url: '/newMall/lotteryActivity/openLotteryActivity',
    method: 'post',
    data
  })
}

// 抽奖活动列表暂停
export function pauseLotteryActivity(data) {
  return request({
    url: '/newMall/lotteryActivity/pauseLotteryActivity',
    method: 'post',
    data
  })
}

// 抽奖活动列表停止
export function stopLotteryActivity(data) {
  return request({
    url: '/newMall/lotteryActivity/stopLotteryActivity',
    method: 'post',
    data
  })
}

// 抽奖活动新建
export function createLotteryActivity(data) {
  return request({
    url: '/newMall/lotteryActivity/createLotteryActivity',
    method: 'post',
    data
  })
}

// 抽奖活动查询详情
export function getLotteryActivity(data) {
  return request({
    url: '/newMall/lotteryActivity/getLotteryActivity',
    method: 'GET',
    data
  })
}

// 抽奖活动修改
export function updateLotteryActivity(data) {
  return request({
    url: '/newMall/lotteryActivity/updateLotteryActivity',
    method: 'post',
    data
  })
}

// 获取抽奖记录列表
export function getLotteryRecordList(data) {
  return request({
    url: '/newMall/lotteryRecord/getLotteryRecordList',
    method: 'GET',
    data
  })
}

// 获取抽奖记录总额
export function getLotteryRecordReport(data) {
  return request({
    url: '/newMall/lotteryRecord/getLotteryRecordReport',
    method: 'GET',
    data
  })
}

// 抽奖活动记录导出
export function luckdrawExportToExcel(data) {
  return request({
    url: '/newMall/lotteryRecord/exportActivityReportList',
    responseType: 'blob',
    method: 'get',
    data
  })
}

// 抽奖单个活动记录导出
export function lotteryRecordsListExportToExcel(data) {
  return request({
    url: '/newMall/lotteryRecord/exportActivityReport',
    responseType: 'blob',
    method: 'get',
    data
  })
}


// 换购活动列表
export function getExchangeActivityList(data) {
  return request({
    url: '/newMall/exchangeActivity/getExchangeActivityList',
    method: 'post',
    data
  })
}

// 换购活动启用
export function openExchangeActivity(data) {
  return request({
    url: '/newMall/exchangeActivity/openExchangeActivity',
    method: 'post',
    data
  })
}

// 换购活动暂停
export function pauseExchangeActivity(data) {
  return request({
    url: '/newMall/exchangeActivity/pauseExchangeActivity',
    method: 'post',
    data
  })
}

// 换购活动停止
export function stopExchangeActivity(data) {
  return request({
    url: '/newMall/exchangeActivity/stopExchangeActivity',
    method: 'post',
    data
  })
}

// 换购活动新建
export function createExchangeActivity(data) {
  return request({
    url: '/newMall/exchangeActivity/createExchangeActivity',
    method: 'post',
    data
  })
}

// 查询换购活动详情
export function getExchangeActivityDetail(data) {
  return request({
    url: '/newMall/exchangeActivity/getExchangeActivityDetail',
    method: 'post',
    data
  })
}

// 更新换购活动详情
export function updateExchangeActivity(data) {
  return request({
    url: '/newMall/exchangeActivity/updateExchangeActivity',
    method: 'post',
    data
  })
}

// 更新换购活动详情
export function exchangeActivityDashboard(data) {
  return request({
    url: '/newMall/exchangeActivity/exchangeActivityDashboard',
    method: 'post',
    data
  })
}

// 主商品业绩分析
export function productPerformanceAnalysis(data) {
  return request({
    url: '/newMall/exchangeActivity/productPerformanceAnalysis',
    method: 'post',
    data
  })
}

// 换购商品业绩分析
export function exchangeProductPerformanceAnalysis(data) {
  return request({
    url: '/newMall/exchangeActivity/exchangeProductPerformanceAnalysis',
    method: 'post',
    data
  })
}

// 导出换购的活动数据
export function exportActivityReportList(data) {
  return request({
    url: '/newMall/exchangeActivity/exportActivityReportList',
    method: 'post',
    responseType: 'blob',
    data
  })
}

// 导出换购活动数据面板统计
export function exportExchangeActivityDashboard(data) {
  return request({
    url: '/newMall/exchangeActivity/exportExchangeActivityDashboard',
    method: 'post',
    responseType: 'blob',
    data
  })
}

// 导出主商品业绩分析
export function exportProductPerformanceAnalysis(data) {
  return request({
    url: '/newMall/exchangeActivity/exportProductPerformanceAnalysis',
    method: 'post',
    responseType: 'blob',
    data
  })
}

// 导出换购商品业绩分析
export function exportExchangeProductPerformanceAnalysis(data) {
  return request({
    url: '/newMall/exchangeActivity/exportExchangeProductPerformanceAnalysis',
    method: 'post',
    responseType: 'blob',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/shop/selfpromotionManage.js